import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=442b665d&"
import script from "./similar.vue?vue&type=script&lang=js&"
export * from "./similar.vue?vue&type=script&lang=js&"
import style0 from "./similar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports